<template>
  <section class="professional-card"
           :class="{ 'professional-card-active' : hoverProfessionalId === professional.id }"
           :id="'professional-card' + professional.id"
           @mouseover="hoverProfessional(professional, 'hover')"
           @mouseout="hoverProfessional(professional, 'out')">
    <div class="d-flex">
      <div>
        <professional-picture :professional="professional" :imgSize="64"/>
      </div>
      <div class="flex-grow-1 pl-3">
        <div class="d-flex justify-content-start align-items-center">
          <div>
            <h3 class="m-0">
              {{ index + 1 }}. 
              <a class="text-primary-link" :href="`/cleaner/${professional.id}`" target="_blank">{{ professional.name | firstName }}</a>
            </h3>
          </div>
          <div class="px-2" v-if="professional.has_vacuum_cleaner">
            <img :id="`has-vacuum${professional.id}`"
                 src="/static/img/badge-vacuum-cleaner.svg"
                 alt=""
                 width="24">
            <b-popover :target="`has-vacuum${professional.id}`"
                       placement="bottom"
                       :title="$t('message.professional.has_vacuum_cleaner')"
                       triggers="hover"
                       :content="$t('message.professional.has_vacuum_cleaner_detail')"/>
          </div>
          <div class="px-2" v-if="professional.professional_pet_types.length > 0">
            <img :id="`pet-types${professional.id}`"
                 src="/static/img/badge-inconvenient-pet.svg"
                 alt=""
                 width="24">
            <b-popover :target="`pet-types${professional.id}`"
                       placement="bottom"
                       :title="$t('message.professional.inconvenient_pet')"
                       triggers="hover"
                       :content="getPetTypes(professional.professional_pet_types)"/>
          </div>
          <div class="flex-fill text-right" v-if="professional.distance">
            {{ professional.distance | distance }}
          </div>
        </div>
        <div class="pt-2 pb-3">
          <div v-if="professional.job_qty > 0">
            <i class="fas fa-star -rating-star"></i> {{ Number(professional.rating).toFixed(1) }}
            ·
            <a href=""
               class="text-primary-link no-underline"
               @click.prevent="openProfessionalReviewsModal(professional)">
              {{ professional.rating_qty }} {{ $tc('message.professional.review', professional.rating_qty) }}
            </a>
            ·
            <span>
              {{ professional.job_qty | numberWithCommas }}
              {{ $tc('message.professional.job', professional.job_qty) }}
            </span>
            ·
            <span>
              {{ globalState.cities[professional.province_id] | multiLangName }}
            </span>
          </div>
          <div v-else>
            <span class="label label-success">{{ $t('message.professional.new') }}</span>
            <span class="-status-alert">{{ $t('message.professional.special_offer') }}</span>
          </div>
        </div>
      </div>
      <!-- 
      <div>
        <button-favorite-professional :professional="professional" v-if="user"/>
      </div>
      -->
    </div>
    <div class="mt-2" v-if="professional.is_excellent === 1">
      <router-link to="/excellent-provider">
        <img src="/static/img/ic_badge_excellent.png"
              width="28"
              v-b-popover.hover.top="$i18n.t('message.professional.excellent_provider_detail', {name: firstName(professional.name)})"
              :title="$i18n.t('message.professional.excellent_provider_title')">
      </router-link>
      {{ $t('message.professional.excellent_provider_title') }}
    </div>
    <div class="mt-2" v-if="professional.spoken_languages.length > 0">
      {{ $t('message.professional.spoken_languages') }}: <label>{{ professional.spoken_languages }}</label>
    </div>
    <div class="pt-3 text-right">
      <router-link :to="`/cleaner/${professional.id}`" 
                   target="_blank" 
                   class="btn btn-outline-secondary">{{ $t('message.professional.view_profile') }}</router-link>
      <button-select-professional :professional="professional"/>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ButtonSelectProfessional from '../components/ButtonSelectProfessional'
  import ButtonFavoriteProfessional from '../components/ButtonFavoriteProfessional'
  import i18n from '../../../helpers/i18nHelpers'
  import ProfessionalPicture from '../../professional/components/ProfessionalPicture'
  import ProfessionalVaccination from '../../professional/components/ProfessionalVaccination'

  export default {
    props: ['professional', 'index'],
    components: {
      ButtonSelectProfessional,
      ButtonFavoriteProfessional,
      ProfessionalPicture,
      ProfessionalVaccination
    },
    data () {
      return {
        descriptionLength: 180,
        displayShortDescription: false
      }
    },
    computed: {
      ...mapGetters({
        bookingState: 'booking/getState',
        globalState: 'globalVal/getState',
        hoverProfessionalId: 'booking/getHoverProfessionalId',
        preBookingData: 'booking/getPreBookingData',
        user: 'auth/getUser'
      })
    },
    methods: {
      getPetTypes (professionalPetTypes) {
        const petTypes = []
        for (const professionalPetType of professionalPetTypes) {
          let petTypeName = (this.$i18n.locale === 'th') ? professionalPetType.pet_type.name_th : professionalPetType.pet_type.name_en
          if (professionalPetType.pet_type.is_other === 1) {
            petTypeName = professionalPetType.other_remark
          }
          petTypes.push(petTypeName)
        }
        return petTypes.join(', ')
      },
      provideIroningService (professional) {
        for (let professionalService of professional.professional_services) {
          if (professionalService.service_id === 2) {
            return true
          }
        }
        return false
      },
      showMoreDescription (fullDescription) {
        this.$refs.professionalDescription.innerHTML = '<span>' + fullDescription.replace(/\\/g, '') + '</span>'
      },
      openProfessionalReviewsModal (professional) {
        if (professional.rating_qty > 0) {
          const professionalData = {
            id: professional.id,
            name: professional.name,
            picture: professional.picture
          }
          this.$parent.$refs.cleanerReviewsModal.setProfessionalData(professionalData)
        }
      },
      hoverProfessional (professional, action) {
        let professionalId = professional.id
        if (action === 'out') {
          professionalId = null
        }
        if (professional.service_cost) {
          this.$store.commit('booking/SET_BOOKING_COST', {totalPrice: professional.service_cost})
        }
        this.$store.commit('booking/SET_HOVER_PROFESSIONAL_ID', professionalId)
      },
      firstName (professionalName) {
        return this.$options.filters.firstName(professionalName)
      }
    },
    mounted () {
      if (this.professional.short_description && i18n.locale === 'th') {
        this.displayShortDescription = true
      }
    },
    created () {
      if (this.$mq.phone) {
        this.descriptionLength = 100
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/Professional.vue